export const EXPERIMENTS_PROMPT_LOGIN_IN_MODAL = 'specs.wixForum.PromptLoginInModal';
